"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfflineRechargeGuide = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var OfflineRechargeGuide = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(OfflineRechargeGuide, _super);
    function OfflineRechargeGuide() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '线下转账指引';
        _this.code = '106015';
        _this.desc = '线下转账指引';
        _this.requestParams = new zl_1.OfflineRechargeGuideRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return OfflineRechargeGuide;
}(service_1.BaseService));
exports.OfflineRechargeGuide = OfflineRechargeGuide;
//# sourceMappingURL=offlineRechargeGuide.js.map